<template>
	<div class="main">
		<div class="container">
			<h3>用户服务协议</h3>
			<p></p>
			<p>欢迎使用人民党建云产品及服务！</p>
			<p><span>一、条款的接受</span></p>
			<p>在使用人民党建云产品之前，请您认真阅读并遵守《用户服务协议》（以下简称“本协议”）以及《隐私政策》。</p>
			<p>请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、争议解决和法律适用条款。免除或者限制责任的条款可能将以加粗字体显示，您应重点阅读。</p>
			<p>当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，或您按照激活页面提示填写信息、阅读并同意本协议且完成全部激活程序后，或您以其他人民党建云允许的方式实际使用本服务时，即表示您已充分阅读、理解并接受本协议的全部内容，本协议即产生法律约束力。此后，用户不得以未阅读本服务条款内容作任何形式的抗辩。
			</p>
			<p>制定本协议的目的在于维护人民党建云产品秩序，保障用户的合法权益。制定本条例的依据是国家有关法律、法规，当本条例与国家法律、法规冲突时，以国家法律、法规为准。</p>
			<p><span>二、协议内容和效力</span></p>
			<p>本协议内容包括本协议正文及所有我们已经发布或将来可能发布的《隐私政策》、各项政策、规则、声明、通知、警示、提示、说明（以下简称“规则”）。前述规则为本协议不可分割的组成部分，与本协议具有同等法律效力。</p>
			<p><span>三、服务内容</span></p>
			<p>1、人民党建云产品包括人民党建云官网（域名为
				djy.people.com.cn）、人民党建云移动客户端及其他方式使用人民党建云服务的形式。人民党建云会不断丰富您使用本服务的终端、形式等，如您已注册使用一种形式的服务，则可以以同一账号使用其他服务，本协议自动适用于您对所有版本的软件和服务的使用。
			</p>
			<p>2、人民党建云依据本协议、《隐私政策》以及其他适用的规则，许可您对人民党建云产品进行不可转让的、非排他性的使用。本条及本协议其他条款未明示授权的其他一切权利仍由人民党建云保留，您在行使这些权利时须另外取得人民党建云的书面许可。人民党建云如果未行使前述任何权利，并不构成对该权利的放弃。
			</p>
			<p>3、人民党建云有权自行决定对服务或服务任何部分及其相关功能、应用软件进行变更、升级、修改、转移，并在人民党建云官网（djy.people.com.cn）或移动客户端上公示通知。 </p>
			<p>4、人民党建云有权根据互联网的发展和中华人民共和国有关法律、法规的变化，不断地完善服务质量并依此修改本服务条款。用户的权利以及义务的表述，均以最新的服务条款为准，一经使用，视为您已接受新的服务条款的约束。
			</p>
			<p><span>四、人民党建云用户资格的有关规定</span></p>
			<p>1、人民党建云用户应以党组织的形式入驻，党组织应保证所提交的资料真实有效。用户的个人资料发生变化时，应及时修改个人资料。</p>
			<p>2、人民党建云帐号注册资料包括但不限于用户的帐号名称、头像、密码、注册或更新人民党建云帐号时输入的所有信息以及用户使用人民党建云各单项服务时输入的名称、头像等所有信息。</p>
			<p>3、用户在注册人民党建云帐号时承诺遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等七条底线，不得在人民党建云帐号注册资料中出现违法和不良信息，且用户保证其在注册和使用帐号时，用户独立承担其发布内容的责任。用户对服务的使用必须遵守所有适用于服务的地方法律、国家法律和国际法律。用户承诺不得制作、复制、发布、传播以下信息：
			</p>
			<p>（1）违反宪法或法律法规规定的；</p>
			<p>（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
			<p>（3）损害国家荣誉和利益的，损害公共利益的；</p>
			<p>（4）煽动民族仇恨、民族歧视，破坏民族团结的；</p>
			<p>（5）破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
			<p>（6）散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
			<p>（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
			<p>（8）侮辱或者诽谤他人，侵害他人合法权益的；</p>
			<p>（9）以非法民间组织名义活动的；</p>
			<p>（10）含有法律、行政法规禁止的其他内容的。</p>
			<p>4、若用户提供给人民党建云的帐号注册资料不准确，不真实，含有违法或不良信息的，人民党建云有权不予注册，并保留终止用户使用人民党建云各项服务的权利。若用户以虚假信息骗取帐号注册或帐号头像、个人简介等注册资料存在违法和不良信息的，人民党建云有权采取通知限期改正、暂停使用、注销登记等措施。对于冒用关联机构或社会名人注册帐号名称的，人民党建云有权注销该帐号，并向政府主管部门进行报告。
			</p>
			<p>5、根据相关法律、法规规定以及考虑到人民党建云产品的重要性，用户同意：</p>
			<p>（1）在注册人民党建云帐号时提交个人有效信息进行实名认证；</p>
			<p>（2）提供及时、详尽及准确的账户注册资料；</p>
			<p>（3）不断更新注册资料，符合及时、详尽准确的要求；</p>
			<p>6、为使用户及时、全面了解人民党建云提供的各项服务，用户同意，人民党建云可以多次、长期向用户发送各类短信息而无需另行获得用户的同意。</p>
			<p>7、用户同意与注册、使用人民党建云帐号相关的一切资料、数据和记录，包括但不限于人民党建云帐号、注册资料、所有登录、和相关的使用统计数字等归人民数据管理（北京）有限公司所有。发生争议时，用户同意以人民党建云的系统数据为准，人民党建云保证该数据的真实性。
			</p>
			<p><span>五、用户的帐号、密码</span></p>
			<p>1、用户须妥善保管其用户名及密码，因密码被盗或泄露造成的全部责任和损失均由用户承担。</p>
			<p>2、用户因忘记密码或密码被盗向人民党建云产品查询密码时，必须提供完全正确的注册信息，否则人民党建云有权基于保密原则不予告知。</p>
			<p>3、用户名和密码只能供用户本人使用，不得以任何形式转让或授权他人使用，如果发现同一帐号和密码在同一时间内被多人同时登录使用，人民党建云有权取消此帐号的用户资格，无须承担任何责任。</p>
			<p>4、用户名中不得含有任何威胁、恐吓、漫骂、庸俗、亵渎、色情、淫秽、非法、反动、前后矛盾、攻击性、伤害性、骚扰性、诽谤性、辱骂性的或侵害他人知识产权的文字，否则人民党建云有权不予注册或随时注销该账号。</p>
			<p>六、隐私制度</p>
			<p>1、您在人民党建云平台注册的账户具有密码保护功能，以确保您基本信息资料的安全，请您妥善保管账户及密码信息。</p>
			<p>2、人民党建云努力采取各种合理的物理、电子和管理方面的安全措施来保护您的信息，使您存储在人民党建云平台中的信息和通信内容不会被泄漏、毁损或者丢失，同时也请您注意在信息网络上不存在绝对完善的安全措施，请妥善保管好相关信息。
			</p>
			<p>3、您应当保管好终端、账号及密码，并妥善保管相关信息和内容。因您自身原因导致的数据丢失或被盗以及在人民党建云产品中相关数据的删除或储存失败的责任由您自行承担。</p>
			<p>4、人民党建云保证不对外公开或向第三方提供单个用户的注册资料及用户在使用网络服务时存储在人民党建云平台的非公开内容，下列情况除外：</p>
			<p>（1）用户本人（或监护人）授权人民党建云透露这些信息；</p>
			<p>（2）根据法律规定，对于违反有关法律法规、侵犯他人隐私和名誉等内容，人民党建云具有删除信息、保存有关记录并依法向有关部门提供的权利。</p>
			<p>（3）在不透露用户隐私资料的前提下，人民党建云有权对整个用户数据库进行分析并对用户数据库进行适当的使用。</p>
			<p>5、其他隐私条款见《隐私政策》。</p>
			<p><span>七、免责条款</span></p>
			<p>1、鉴于人民党建云的产品特性为党组织入驻形式，个人无法直接注册登录且人民党建云无自主的信息采集、分析功能，党员的个人信息、动态等均由该党组织进行采集和上传。此外，除党员姓名、手机号码为必要信息，其余信息均非必要信息，且不上传不会影响产品使用。因此，除人民党建云违反隐私政策披露党员信息的行为外，人民党建云对党员个人信息及隐私信息泄露等情形不承担责任。
			</p>
			<p>2、人民党建云对任何直接、间接、偶然、特殊及继起的损害不负责任，并不予赔偿。这些损害来自：网络故障；不正当下载、使用人民党建云产品内容；在网上进行交易，非法使用服务等。</p>
			<p>3、用户须对其自身在使用人民党建云产品所提供的服务时的一切行为、活动（不论是否故意）负全部责任。</p>
			<p>4、不论在何种情况下，人民党建云均不对由于Internet连接故障、电脑故障、通讯或其他系统的故障、电力故障、罢工、劳动争议、暴乱、起义、骚乱、生产力或生产资料不足、火灾、洪水、风暴、爆炸、战争、政府行为、国际、国内法院的命令或第三方的不作为及其他不可抗力而造成的不能服务或延迟服务承担责任。
			</p>
			<p><span>八、关于中断或终止服务</span></p>
			<p>1、鉴于网络服务的特殊性（包括但不限于服务器的稳定性问题、恶意的网络攻击等行为的存在及其他无法控制的情形），用户同意人民党建云有权随时中断或终止部分或全部的服务，若发生该等中断、终止服务或数据丢失的情形，人民党建云将尽可能及时通过网页公告、系统通知、短信提醒或其他合理方式通知受到影响的用户。
			</p>
			<p>2、用户理解，人民党建云需要定期或不定期地对相关的设备进行检修或者维护，如因此类情况而造成服务在合理时间内的中断、终止服务，人民党建云无需为此承担任何责任，但人民党建云应尽可能事先进行通告。由于不可抗拒的原因（含系统维护和升级），导致用户数据丢失、服务暂停或停止，人民党建云不承担赔偿及其他连带的法律责任，但将尽力减少因此而给用户造成的损失和影响。
			</p>
			<p><span>九、服务内容的知识产权</span></p>
			<p>1、您了解及同意，除非人民党建云另行声明，本协议项下服务包含的所有产品、技术、软件、程序、数据及其他信息（包括但不限于文字、图像、图片、照片、音频、视频、图表、色彩、版面设计、电子文档）的所有知识产权（包括但不限于版权、商标权、专利权、商业秘密等）及相关权利均归人民数据管理（北京）有限公司所有。
			</p>
			<p>2、您应保证，除非取得人民数据管理（北京）有限公司书面授权，对于上述权利您不得（并不得允许任何第三人）实施包括但不限于出租、出借、出售、散布、复制、修改、转载、汇编、发表、出版、还原工程、反向汇编、反向编译，或以其它方式发现原始码等的行为。
			</p>
			<p>3、人民党建云的Logo、商标、图形等及其组合，以及人民党建云其他标识、徽记、人民党建云服务的名称等均为人民数据管理（北京）有限公司及其关联公司在中国和其他国家的注册商标。未经人民数据管理（北京）有限公司书面授权，任何人不得以任何方式展示、使用或做其他处理（包括但不限于复制、传播、展示、镜像、上传、下载等），亦不得向他人表明您有权展示、使用或做其他处理。
			</p>
			<p>4、人民党建云所有的产品、服务、技术与所有应用程序或其组件/功能/名称（以下或简称“技术服务”）的知识产权均归属于人民数据管理（北京）有限公司所有。</p>
			<p>5、您理解并同意授权人民数据管理（北京）有限公司在宣传和推广中使用您的名称及公开渠道可以查询到的企业基本信息，但仅限于表明您属于我们的客户或合作伙伴。</p>
			<p><span>十、协议的说明</span></p>
			<p>1、制定本条例的目的在于维护人民党建云产品使用秩序，保障人民党建云用户的合法权益。</p>
			<p>2、制定本协议的依据是中华人民共和国有关法律、法规，当本条例与国家法律、法规冲突时，以国家法律、法规为准。</p>
			<p>3、党组织或用户愿意接受本条例，方可注册成为人民党建云正式用户。</p>
			<p><span>十一、用户的权利与责任</span></p>
			<p>1、用户享有人民党建云用户的各种权利，可享受人民党建云提供的各项服务。</p>
			<p>2、用户在人民党建云所进行的所有活动应遵守人民党建云的管理条例，遵守中华人民共和国法律、法规，并自行承担因使用人民党建云直接或间接引起的一切法律责任。</p>
			<p>3、用户要注意保管好用户名及密码，用户如发现帐号遭他人非法使用，应立即通知人民党建云管理者。因黑客行为或用户保管疏忽导致帐号、密码遭他人非法使用，人民党建云不承担任何责任。</p>
			<p>4、用户认为自己在人民党建云的权益受到侵害，有权根据人民党建云相关规定进行投诉、申诉。</p>
			<p>5、用户有权对人民党建云管理提出批评、意见、建议，有权就人民党建云管理相关工作提出咨询。</p>
			<p>6、用户需遵守网络道德，注意网络礼仪，做到文明上网。</p>
			<p>7、用户在人民党建云发布信息或者使用人民党建云的服务时还必须符合其他有关国家和地区的法律规定以及国际法的有关规定。用户需遵守法律法规的规定使用人民党建云服务。</p>
			<p>8、用户不得利用人民党建云的服务从事以下活动：</p>
			<p>（1）未经允许，进入计算机信息网络或者使用计算机信息网络资源的；</p>
			<p>（2）未经允许，对计算机信息网络功能进行删除、修改或者增加的；</p>
			<p>（3）未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加的；</p>
			<p>（4）故意制作、传播计算机病毒等破坏性程序的；</p>
			<p>（5）其他危害计算机信息网络安全的行为。</p>
			<p>9、用户不得以任何方式干扰人民党建云的服务。</p>
			<p>10、用户不得滥用人民党建云的服务，包括但不限于：利用人民党建云提供的账号服务发送虚假信息，利用人民党建云服务进行侵害他人知识产权或者合法利益的其他行为。</p>
			<p>11、用户应遵守人民党建云的所有其他规定和程序。</p>
			<p>12、用户须对自己在使用人民党建云服务过程中的行为承担法律责任。用户承担法律责任的形式包括但不限于：对受到侵害者进行赔偿，以及在人民党建云首先承担了因用户行为导致的行政处罚或侵权损害赔偿责任后，用户应给予人民党建云等额的赔偿。
			</p>
			<p>若用户违反以上规定，人民党建云有权作出独立判断，立即暂停或终止对用户提供部分或全部服务，包括锁定、注销、删除用户帐号等措施。用户理解，如果人民党建云发现其终端传输的信息明显属于上述所列内容之一，依据中国法律，人民党建云有义务立即停止传输，保存有关记录，向国家有关机关报告，并且删除含有该内容的地址、目录或关闭服务器。
			</p>
			<p></p>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'policy_index',
		components: {}
	}
</script>

<style lang="scss">
	body {
		background-image: url(../../assets/image/join/bg.jpg);
		background-size: cover;
	}

	.main {
		width: 100%;
		height: auto;
		overflow: hidden;
		line-height: 1;

		.container {
			width: 706px;
			height: auto;
			background-color: #fff;
			margin: 26px auto;
			overflow: hidden;
			padding: 58px 86px;

			h3 {
				font-size: 19px;
				font-family: Source Han Sans CN;
				font-weight: 600;
				color: #282828;
				text-align: center;
				margin-bottom: 45px;
			}

			p {
				font-size: 12px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #717171;
				line-height: 25px;
				text-indent: 2em;
			}

			span {
				font-weight: bold;
				color: #282828;
			}
		}
	}
</style>
